import { render, staticRenderFns } from "./ListVideo.vue?vue&type=template&id=67a08168&scoped=true"
import script from "./ListVideo.vue?vue&type=script&lang=js"
export * from "./ListVideo.vue?vue&type=script&lang=js"
import style0 from "./ListVideo.vue?vue&type=style&index=0&id=67a08168&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a08168",
  null
  
)

export default component.exports